import { INotesInputComponent } from '@modeso/types__aumico-lib-annualreport-be';

export interface IInputDelegate {
    inputComponentData?(inputData: INotesInputComponent, componentIndex: number);
}
